import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

// servicios
import { NotificacionesService } from '../notificaciones.service';
import { UsuarioService } from './usuario.service';

// interfaces
import { IApiResp } from 'src/app/interfaces/api-resp';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuxDataService {

  apiURL: string = environment.apiURL;

  constructor(
    private http: HttpClient,
    private usuarioSrv: UsuarioService,
    private router: Router,
    private notificacionesSrv: NotificacionesService,
  ) { }

  getPoblaciones(cp: string) {
    // Devulve la lista de poblaciones para un cp
    const path = `${this.apiURL}/getPoblaciones/${cp}`;
    const lista = this.http.get<IApiResp>(path)
    return lista;
  }


  getListaServicios() {
    // Devulve la lista de servicios de envío
    const path = `${this.apiURL}/getListaServicios`;
    const lista = this.http.get<IApiResp>(path)
    return lista;
  }



  getTotalesApi() {
    // Devuelve los totales del menú
    const path = `${this.apiURL}/getTotalesApi`;
    const totales = this.http.get<IApiResp>(path)
    return totales;
  }


  getPedidosPorMes() {
    // Devuelve los pedidos de los últimos 12 meses
    const path = `${this.apiURL}/graficos/pedidosPorMes`;
    return this.http.get<IApiResp>(path)
  }

}
